import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaChevronRight, FaUser } from "react-icons/fa";
import Image from "react-bootstrap/Image";
import "./PraiseElement.css";

function PraiseElement({
  id,
  title,
  receiverName,
  receiverProfilePicture,
  senderName,
  senderProfilePicture,
  message,
  values,
  language,
}) {
  const { t } = useTranslation();

  return (
    <Col lg={3} key={id}>
      <Col className="praise-element-card">
        <Col>
          <h5 className="praise-element-title">{title}</h5>
          {senderProfilePicture !== "" ? (
            <Image
              src={senderProfilePicture}
              roundedCircle
              fluid
              style={{ maxWidth: 60 }}
            />
          ) : (
            <FaUser
              style={{
                fontSize: 30,
                color: "#555",
                marginLeft: 10,
                marginRight: 10,
              }}
            />
          )}
          <FaChevronRight
            style={{
              fontSize: 30,
              color: "#555",
              marginLeft: 10,
              marginRight: 10,
            }}
          />
          {receiverProfilePicture !== "" ? (
            <Image
              src={receiverProfilePicture}
              roundedCircle
              fluid
              style={{ maxWidth: 60 }}
            />
          ) : (
            <FaUser
              style={{
                fontSize: 30,
                color: "#555",
                marginLeft: 10,
                marginRight: 10,
              }}
            />
          )}
          <Col className="praise-element-values-badges">
            {values.map((value) => (
              <span key={value._id} className="praise-element-value-badge">
                {language === "es" ? value.title : value.titleEnglish}
              </span>
            ))}
          </Col>

          <hr />
          <h6 className="praise-element-stakeholders">
            {t("Reconocimientos.Reconocimiento.De")} {senderName}
          </h6>
          <h6 className="praise-element-stakeholders">
            {t("Reconocimientos.Reconocimiento.Para")} {receiverName}
          </h6>
          <p className="praise-element-message">{message}</p>
        </Col>
      </Col>
    </Col>
  );
}

export default PraiseElement;
